module.exports = __webpack_public_path__ + "img/toggle-right.0dce1736.svg";